import React from 'react';
import { Link } from 'react-router-dom';
import ServiceCardImage from './ServiceCardImage';
import { getServiceCardImage } from '../utils/mediaUrl';
import './ServiceCard.css';

const formatPrice = (price, currency = 'INR') => {
  const n = parseFloat(price);
  if (Number.isNaN(n)) return null;
  if (currency === 'INR') {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(n);
  }
  return `${currency} ${n.toLocaleString()}`;
};

/**
 * @param {'grid'|'featured'} layout - grid for home, featured for services page
 */
const ServiceCard = ({
  service,
  layout = 'grid',
  id,
  index,
  showPrice = true,
  ctaLabel = 'View Plans',
  ctaTo = '/plans'
}) => {
  const name = service.service_name || service.title || 'Service';
  const tagline = service.short_description || '';
  const body = service.full_description || '';
  const showBody = body && body !== tagline;
  const benefits = Array.isArray(service.benefits) ? service.benefits : [];
  const price = showPrice ? formatPrice(service.price, service.currency) : null;
  const discounted = service.discounted_price && parseFloat(service.discounted_price) < parseFloat(service.price);
  const image = getServiceCardImage(service);
  const showImage = layout === 'featured' || Boolean(image);

  return (
    <article
      className={`service-card-pro ${layout === 'featured' ? 'service-card-pro--featured' : 'service-card-pro--grid'}`}
      id={id}
    >
      {showImage && (
        <ServiceCardImage
          service={service}
          className={layout === 'featured' ? 'service-card-pro__media--featured' : 'service-card-pro__media'}
          alt={name}
        />
      )}

      <div className="service-card-pro__body">
        {layout === 'grid' && Number.isInteger(index) && (
          <span className="service-card-pro__index">{String(index + 1).padStart(2, '0')}</span>
        )}
        <h3 className="service-card-pro__title">{name}</h3>

        {tagline && <p className="service-card-pro__tagline">{tagline}</p>}

        {layout === 'featured' && showBody && (
          <p className="service-card-pro__description">{body}</p>
        )}

        {layout === 'grid' && !tagline && body && (
          <p className="service-card-pro__description service-card-pro__description--compact">{body}</p>
        )}

        {layout === 'featured' && benefits.length > 0 && (
          <ul className="service-card-pro__benefits">
            {benefits.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        )}
      </div>

      <div className={`service-card-pro__footer${!price ? ' service-card-pro__footer--cta-only' : ''}`}>
        {price && (
          <div className="service-card-pro__price">
            <span className="service-card-pro__price-label">From</span>
            <span className="service-card-pro__price-value">{price}</span>
            {discounted && (
              <span className="service-card-pro__price-old">
                {formatPrice(service.discounted_price, service.currency)}
              </span>
            )}
          </div>
        )}
        <Link to={ctaTo} className="service-card-pro__cta">
          {ctaLabel}
        </Link>
      </div>
    </article>
  );
};

export default ServiceCard;
